export default "__VITE_ASSET__6c7ce76c__"